import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, Package } from "lucide-react";
import { StatusBadge, fdate } from "@/pages/portal/Dashboard";

const COLUMNS = [
  ["Aprovado", "Aprovados"],
  ["Em produção", "Em produção"],
  ["Concluído", "Concluídos"],
  ["Entregue", "Entregues"],
];

export default function AdminPedidos() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/quote-requests").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (!items) {
    return <div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-slate-600" /></div>;
  }

  return (
    <div data-testid="admin-orders-page">
      <h1 className="display text-3xl font-extrabold uppercase">Pedidos / Produção</h1>
      <p className="mt-1 text-sm text-slate-500">
        Orçamentos aprovados viram pedidos e seguem para a produção.
      </p>

      <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
        {COLUMNS.map(([status, title]) => {
          const list = items.filter((q) => q.status === status);
          return (
            <section key={status} className="card-tactical rounded-md p-5" data-testid={`orders-col-${status.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\s+/g, "-")}`}>
              <div className="flex items-center justify-between">
                <h2 className="display text-lg font-bold uppercase tracking-wide">{title}</h2>
                <span className="mono text-sm text-orange-400">{list.length}</span>
              </div>
              <ul className="mt-4 space-y-3">
                {list.map((q) => (
                  <li key={q.id}>
                    <Link to={`/solicitacoes/${q.id}`}
                      className="block rounded-md border border-slate-800 bg-slate-900/40 p-3.5 hover:border-orange-900/60 transition-colors"
                      data-testid={`order-card-${q.number}`}>
                      <div className="flex items-center justify-between gap-2">
                        <span className="mono text-sm text-slate-200">{q.number}</span>
                        <StatusBadge status={q.status} />
                      </div>
                      <div className="mt-1.5 text-xs text-slate-400 truncate">{q.part_name} · {q.quantity} un.</div>
                      <div className="text-xs text-slate-600 truncate">{q.client_name} · {fdate(q.created_at)}</div>
                    </Link>
                  </li>
                ))}
                {!list.length && (
                  <li className="py-6 text-center text-xs text-slate-600">
                    <Package className="w-6 h-6 mx-auto mb-2 text-slate-700" strokeWidth={1.25} />
                    Nenhum pedido
                  </li>
                )}
              </ul>
            </section>
          );
        })}
      </div>
    </div>
  );
}
